var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgriculturaleadership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "5l9u3e1vya",
    d: "M0 0.288L24.563 0.288 24.563 30.6 0 30.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8A16B",
    d: "M4.588 15.299v-2.154H7.7c-.01.459-.018 1.208-.005 2.154H4.588zM17.55 15.299v-2.154h3.114c-.01.459-.018 1.208-.005 2.154h-3.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8A16B",
    d: "M16.789 15.299v-2.154h3.113c-.01.459-.018 1.208-.005 2.154H16.79z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .612)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dc2m14i4bb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5l9u3e1vya"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7A6130",
    d: "M24.09 11.585h-9.881c-.059 0-.115.013-.17.034-.018.007-.034.019-.052.029-.023.012-.047.02-.068.037-.063.048-.125.084-.188.128v-.572c1.616-.516 2.82-1.88 3.016-3.532h3.22c.213 0 .399-.14.456-.344.057-.205-.028-.423-.21-.533l-3.922-2.39L14.708.927c-.176-.389-.564-.639-.99-.639h-2.813c-.426 0-.814.25-.99.64l-.808 1.795v.002l-.769 1.707-3.94 2.4c-.18.11-.266.328-.209.533.057.204.244.344.457.344h3.219c.195 1.653 1.402 3.017 3.02 3.532v.707c-.113-.076-.227-.156-.34-.252-.022-.018-.05-.03-.076-.044-.02-.01-.036-.024-.056-.032-.056-.022-.114-.035-.174-.035H.474c-.262 0-.474.211-.474.473v1.755c0 .262.212.474.474.474h3.164v.873c0 .262.213.474.475.474h3.602c.093 3.346.478 8.309 1.836 11.71.072.18.246.299.44.299h.689v2.484c0 .262.212.473.474.473h2.197c.262 0 .474-.211.474-.473v-2.484h.543c.115 0 .226-.042.313-.118.225-.198 2.026-2.092 2.129-11.891h3.567c.262 0 .474-.212.474-.474v-.873h3.238c.262 0 .474-.212.474-.474v-1.755c0-.262-.212-.473-.474-.473zm-12.055 1.732c.06.003.12.011.18.01l-.18-.01zM8.823 7.71h6.965c-.247 1.586-1.71 2.808-3.479 2.808-1.771 0-3.238-1.222-3.486-2.808zm3.486 3.755c.16 0 .319-.009.474-.024v.849c-.196.056-.39.095-.583.097-.122-.001-.245-.015-.368-.037v-.909c.158.015.316.024.477.024zm-7.723 3.222v-2.153H7.7c-.01.459-.019 1.207-.005 2.153H4.586zm9.557 12.009h-1.416v-3.953c0-.262-.213-.473-.475-.473s-.473.211-.473.473v3.953h-1.463C9.06 23.312 8.731 18.354 8.658 15.17l.002-.01v-2.627h1.056l.484 4.577c.026.241.229.424.471.424h3.109c.243 0 .445-.183.471-.424l.484-4.577h1.094v2.627c0 .06.014.118.035.172-.063 8.33-1.366 10.836-1.72 11.363zm5.76-12.009h-3.09c0-.681-.008-1.4-.026-2.153h3.116v2.153z",
    mask: "url(#dc2m14i4bb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B8A16B",
    d: "M14.144 27.308h-1.418v-3.953c0-.262-.211-.474-.473-.474s-.475.212-.475.474v3.953h-1.461C9.06 23.924 8.73 18.965 8.658 15.782l.002-.01v-2.628h1.057l.483 4.579c.025.24.228.423.471.423h3.11c.241 0 .445-.183.47-.423l.484-4.579h1.094s.014 2.747.035 2.801c-.063 8.329-1.367 10.834-1.72 11.363"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgriculturaleadership);
export default __webpack_public_path__ + "static/media/agriculturaleadership.fad12a799707262f76d57646807728ab.svg";
export { ForwardRef as ReactComponent };